import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <article className='banner'></article>
    );
};

export default Banner;